<template>
  <div class="flex-container">
    <div class="flexbox-item flexbox-item-1">
      <v-select
        class="group-item"
        :items="groupsOptions || []"
        v-model="group"
        label="Grupos"
      />
      <v-list two-line>
        <template v-for="(item, index) in filteredList">
          <v-subheader
            class="mt-4"
            v-if="showSubgroup(index, item.subgroup, filteredList)"
            :key="item.itemName"
          >
            {{ item.subgroup }}
          </v-subheader>
          <v-divider
            v-if="showSubgroup(index, item.subgroup, filteredList)"
            :key="index"
          />
          <v-list-tile :key="item.itemName" @click="openLink(item)">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.itemTitle }} </v-list-tile-title>
              <v-list-tile-sub-title
                >{{ item.itemText }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </div>
    <div class="flexbox-item flexbox-item-2">
      <div class="image" v-if="this.image">
        <div class="image-size">
          <div class="image-wrap">
            <a :href="this.image.link" target="_blank">
              <img :src="this.image.image" class="image" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import cms from '@/content'
import { Sponsors } from '../../models/Content'
export default {
  props: {
    sponsor: { type: String }
  },
  data() {
    return {
      group: null,
      subgroup: [],
      image: null,
      imagelogo: cms.getlogotypes()
    }
  },

  computed: {
    ...mapGetters(['user']),

    groupsOptions() {
      const groups = Sponsors.query()
        .where(group => {
          return (
            group.specialty.includes(this.user.specialty) &&
            group.sponsor === this.sponsor &&
            group.show === true
          )
        })
        .get()
        .map(group => group.group)
      return groups ? groups : ''
    },

    filteredList() {
      const items = Sponsors.query()
        .where(group => {
          return (
            group.specialty.includes(this.user.specialty) &&
            group.sponsor === this.sponsor &&
            group.group === this.group &&
            group.show === true
          )
        })
        .get()
      return items ? _.sortBy(items, ['group', 'subgroup']) : []
    }
  },
  methods: {
    openLink(item) {
      if (item.airtableLink.length) {
        const url = _.first(item.airtableLink).url
        window.open(url, '_blank')
      } else if (item.externalLink) {
        window.open(item.externalLink, '_blank')
      }
    },
    showSubgroup(index, subgroup, itemList) {
      if (index === 0) {
        return true
      }
      const previousSubgroup = itemList[index - 1].subgroup
      return previousSubgroup !== subgroup
    }
  },
  created() {
    this.group = Sponsors.query()
      .where(group => {
        return (
          group.specialty.includes(this.user.specialty) &&
          group.sponsor === this.sponsor
        )
      })
      .first().group

    this.image = _.find(this.imagelogo, ['text', this.sponsor])
  }
}
</script>

<style>
.flex-container {
  margin: 25px 25px 25px 25px;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  background: #fff;
  height: 100%;
}

.flexbox-item-1 {
  margin-top: 25px;
  width: 65%;
  min-width: 300px;
  padding: 25px;
}
.flexbox-item-2 {
  width: 35%;
  display: flex;
  justify-content: center;
  margin-top: 25px;
  min-width: 350px;
}

.group-item {
  width: 40%;
  min-width: 200px;
  margin-bottom: 30px;
}
.subgroup-item {
  width: 60%;
  min-width: 200px;
  margin-bottom: 30px;
}

.image-size {
  display: flex;
  align-items: center;
  width: 5cm;
  height: 3cm;
}
</style>
